import * as React from 'react';
import {
  Datagrid,
  List,
  SimpleShowLayout,
  TextField,
  BooleanField,
  TextInput, required,
  BooleanInput,
  FormDataConsumer,
  SelectArrayInput,
  useTranslate,
} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";
import ShowView from "../../../components/ShowView";

import { ColorField, ColorInput } from 'react-admin-color-input';
import { SvgIcon } from '@mui/material';
import { ReminderEnum } from '../../../constants/choices';
import { ReminderTitle } from '../status/Status';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { isMobile } from 'react-device-detect';

export const StatusLoadingList = (props) => (

  <List {...props} sort={{ field: 'createdAt', order: 'ASC' }} >
    <Datagrid rowClick="edit">
      <TextField source="title" label="عنوان" />
      <BooleanField width="10%" source="isDefault" TrueIcon={TaskAltIcon} FalseIcon={SvgIcon} label="پیشفرض شروع " />
      <BooleanField width="10%" source="isEnd" TrueIcon={TaskAltIcon} FalseIcon={SvgIcon} label="پیشفرض پایان" />
      <BooleanField width="10%" source="needRemind" TrueIcon={TaskAltIcon} FalseIcon={SvgIcon} label="یادآوری" />
      {!isMobile ? (<ReminderTitle label="یادآوری بعد از" source="remindsAfter" />) : null}

      <ColorField source="stColor" label="رنگ وضعیت" />

    </Datagrid>
  </List>
);

export const StatusLoadingEdit = (props) => {
  const translate = useTranslate();

  return (
    <EditView {...props} >
      <TextInput source="title" validate={required()} />
      <BooleanInput source="isDefault" label="پیشفرض شروع" />
      <BooleanInput source="isEnd" label="پیشفرض پایان" />
      <BooleanInput source="needRemind" label="یادآوری شود" />
      <FormDataConsumer>
        {({ formData, ...rest }) => formData.needRemind && <div className=' grid grid-cols-6 gap-4'>
          <SelectArrayInput className='col-start-1 col-end-3' variant='outlined' label="یادآوری بعد از" source="remindsAfter" choices={ReminderEnum} />
          <TextInput className='col-start-1 col-end-3' variant='outlined' source="messageTemplate" label="متن یادآوری"
            placeholder={translate('resources.statusLoading.hints.messageTemplate')}
            defaultValue={translate('resources.statusLoading.hints.messageTemplate')}
            inputProps={{
              maxLength: 300,
            }}
            multiline rows={5} />
        </div>
        }
      </FormDataConsumer>
      <ColorInput source="stColor" label="رنگ درخواست" />
    </EditView>
  )
};
export const StatusLoadingShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <BooleanField source="isDefault" TrueIcon={TaskAltIcon} FalseIcon={SvgIcon} label="پیشفرض شروع " />
      <BooleanField source="isEnd" TrueIcon={TaskAltIcon} FalseIcon={SvgIcon} label="پیشفرض پایان" />
      <TextField source="objectId" />
      <ColorField source="stColor" label="رنگ درخواست" />

    </SimpleShowLayout>
  </ShowView >
);

export const StatusLoadingCreate = (props) => {
  const translate = useTranslate();
  return (
    <CreateView {...props}>
      <TextInput source="title" label="عنوان" />
      <BooleanInput source="isDefault" label="پیشفرض شروع" />
      <BooleanInput source="isEnd" label="پیشفرض پایان" />
      <BooleanInput source="needRemind" label="یادآوری شود" />
      <FormDataConsumer>
        {({ formData, ...rest }) => formData.needRemind && <div className=' grid grid-cols-6 gap-4'>

          <SelectArrayInput className='col-start-1 col-end-3' style={{ minwidth: "100px" }} variant='outlined' label="یادآوری بعد از" source="remindsAfter" choices={ReminderEnum} />
          <TextInput className='col-start-1 col-end-3' variant='outlined' source="messageTemplate" label="متن یادآوری"
            placeholder={translate('resources.statusLoading.hints.messageTemplate')}
            defaultValue={translate('resources.statusLoading.hints.messageTemplate')}
            inputProps={{
              maxLength: 300,
            }}
            multiline rows={5} />
        </div>
        }
      </FormDataConsumer>
      <ColorInput source="stColor" label="رنگ درخواست" />
    </CreateView>
  )
};

